var _excluded = ["title", "stroke"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgStar = function SvgStar(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Star' : _ref$title,
    stroke = _ref.stroke,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 46 44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 35.37l-12.779 6.718 2.44-14.229L2.325 17.782l14.287-2.076L23 2.76l6.39 12.946 14.286 2.076-10.338 10.077 2.44 14.23L23 35.37z",
    stroke: stroke || props.color,
    strokeWidth: 2,
    fill: "#FFF",
    fillRule: "evenodd"
  }));
};
SvgStar = pure(SvgStar);
SvgStar.displayName = 'SvgStar';
export default SvgStar;